import { Table, Menu, ActionIcon, Badge } from "@mantine/core";
import { IconDots, IconPencil, IconTrash } from "@tabler/icons-react";

export function UsersTable({ users, onEdit, onDelete, deletingId, currentUserId }) {
  const rows = users.map((user) => (
    <Table.Tr key={user.id}>
      <Table.Td style={{ fontWeight: 500 }}>{user.name}</Table.Td>
      <Table.Td>{user.email}</Table.Td>
      <Table.Td>
        <Badge variant={user.role === 'ADMIN' ? 'filled' : 'light'} color={user.role === 'ADMIN' ? 'cyan' : 'gray'}>
          {user.role === 'ADMIN' ? 'Admin' : 'User'}
        </Badge>
      </Table.Td>
      <Table.Td>{new Date(user.createdAt).toLocaleDateString()}</Table.Td>
      <Table.Td style={{ textAlign: 'right' }}>
        <Menu position="bottom-end" shadow="md">
            <Menu.Target>
                <ActionIcon variant="subtle" color="gray">
                    <IconDots size={16} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item leftSection={<IconPencil size={14} />} onClick={() => onEdit(user)}>
                    Edit
                </Menu.Item>
                <Menu.Item 
                    color="red" 
                    leftSection={<IconTrash size={14} />} 
                    onClick={() => onDelete(user.id)}
                    disabled={deletingId === user.id || user.id === currentUserId}
                >
                    {deletingId === user.id ? "Deleting..." : "Delete"}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Table.ScrollContainer minWidth={500}>
      <Table verticalSpacing="sm" withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Email</Table.Th>
            <Table.Th>Role</Table.Th>
            <Table.Th>Created At</Table.Th>
            <Table.Th style={{ textAlign: 'right' }}>Actions</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
